import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetResponseSlackBot } from '../../models/slack-bot.interface';

@Injectable({
  providedIn: 'root',
})
export class SlackBotService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  postBotSlack(botId: string, team_id: string, is_enabled: boolean) {
    return this.http.post<any>(`${this.apiAddress}/bot/${botId}/slack`, { team_id, is_enabled });
  }
  getBotSlack(botId: string) {
    return this.http.get<GetResponseSlackBot>(`${this.apiAddress}/bot/${botId}/slack`);
  }
  updateBotSlack(botId: string, is_enabled: boolean, team_id?: string) {
    const body = {
      is_enabled: is_enabled,
      team_id: team_id,
    };
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/slack`, body);
  }
}
